// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__2HG5K","buttons":"SendReceipts_buttons__3vs1z","email":"SendReceipts_email__11ZNc","bookApptTitle":"SendReceipts_bookApptTitle__2e4F8"};